var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 149,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 15.5,
    width: 119,
    height: 119,
    rx: 3.5,
    fill: "white",
    stroke: "#F0F0F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.974 47.5709C51.7435 51.9133 54.4285 57.535 55.029 64.436",
    stroke: "#9799B5",
    strokeWidth: 1.64062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5289 45.6032C60.582 45.6957 61.5107 44.9171 61.6032 43.864C61.6958 42.811 60.9171 41.8823 59.8641 41.7897C58.811 41.6972 57.8823 42.4758 57.7898 43.5289C57.6972 44.5819 58.4759 45.5106 59.5289 45.6032Z",
    fill: "#9799B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4451 61.6302C74.0468 61.6831 74.5775 61.2382 74.6304 60.6364C74.6833 60.0347 74.2384 59.504 73.6366 59.4511C73.0349 59.3983 72.5042 59.8432 72.4513 60.4449C72.3984 61.0467 72.8434 61.5774 73.4451 61.6302Z",
    fill: "#9799B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.445 45.6302C102.047 45.6831 102.578 45.2382 102.63 44.6364C102.683 44.0347 102.238 43.504 101.637 43.4511C101.035 43.3983 100.504 43.8432 100.451 44.4449C100.398 45.0467 100.843 45.5774 101.445 45.6302Z",
    fill: "#9799B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5289 56.6032C80.582 56.6957 81.5107 55.9171 81.6032 54.864C81.6958 53.811 80.9171 52.8823 79.8641 52.7897C78.811 52.6972 77.8823 53.4758 77.7898 54.5289C77.6972 55.5819 78.4759 56.5106 79.5289 56.6032Z",
    fill: "#9799B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8809 63.3178C97.6107 57.7469 100.985 53.641 106.004 51.0002",
    stroke: "#9799B5",
    strokeWidth: 1.64062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9996 55.7752C88.9862 53.5373 90.3217 51.7205 92.0061 50.3249",
    stroke: "#9799B5",
    strokeWidth: 1.64062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4121 56.3737C64.1121 53.9465 63.3567 51.822 62.1459 50.0002",
    stroke: "#9799B5",
    strokeWidth: 1.64062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74H84V102H52C51.4477 102 51 101.552 51 101V74Z",
    fill: "#F0F0F4",
    stroke: "#9799B5",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84 74H99V101C99 101.552 98.5523 102 98 102H84V74Z",
    fill: "#F8F9F9",
    stroke: "#9799B5",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8019 65.4771C46.4401 64.8108 46.9225 64 47.6807 64H77.9764C78.3431 64 78.6804 64.2007 78.8553 64.5229L84 74H67.7143H51.4286L46.8019 65.4771Z",
    fill: "#C3C5D5",
    stroke: "#9799B5",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0864 64.6013C88.2451 64.2362 88.6053 64 89.0035 64H102.382C103.125 64 103.609 64.7823 103.276 65.4472L99 74H84L88.0864 64.6013Z",
    fill: "#C3C5D5",
    stroke: "#9799B5",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 93,
    width: 12,
    height: 5,
    rx: 1,
    fill: "#C3C5D5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 149,
    rx: 9.5,
    stroke: "#F0F0F4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderEmptyState);
export default __webpack_public_path__ + "static/media/orderEmptyState.31d275c0f9af395cde77db80e69ffc38.svg";
export { ForwardRef as ReactComponent };